<template>
  <div>
    <!-- <v-row>
      <v-col cols="12" span="12">
        <v-icon color="success" large class="avatar-icon">mdi-numeric-3</v-icon><span class="pl-4 font-weight-light"><i>Configure the other parameters</i></span>
      </v-col>        
    </v-row>     -->
    <v-row>      
      <v-col cols="6">
        <div class="ml-3 mb-1"><b>Arrival / days</b></div>
        <v-divider class="mb-2"></v-divider>

        <weekdays 
          :days="wizardData.other_arrival_days" 
          field="other_arrival_days" 
          color="primary"
          @updateData="updateData" class="ml-3"/>

        <weekdays_numerical_addon 
          :days="wizardData.other_arrival_days_num"
          field="other_arrival_days_num"
          tag="Days"      
          info="Values (incl. 0) are only saved if the 'day' checkbox above the value is 'checked'" 
          info_font_size="small"          
          @updateData="updateData" 
          class="ml-3"/>

        <v-row>
          <v-col cols="8">
            <v-divider class="mb-1"></v-divider>
          </v-col>
        </v-row>

        <weekdays_checkbox_addon 
          :days="wizardData.other_arrival_days_remove"
          field="other_arrival_days_remove"
          tag="Reset"     
          :selectAll="true"
          info="Resets an arrival day if checked and will overwrite 'days' value. Ignores day selection." 
          info_font_size="small"          
          color="warning"
          @updateData="updateData" 
          class="ml-3"/>

      </v-col>
      <v-col cols="6">
        <div class="ml-3 mb-1"><b>Departure / days</b></div>
        <v-divider class="mb-2"></v-divider>        

        <weekdays 
          :days="wizardData.other_departure_days" 
          field="other_departure_days" 
          color="primary"
          @updateData="updateData" class="ml-3"/>

        <weekdays_numerical_addon 
          :days="wizardData.other_departure_days_num"
          field="other_departure_days_num"
          tag="Days"               
          info="Values (incl. 0) are only saved if the 'day' checkbox above the value is 'checked'" 
          info_font_size="small"          
          @updateData="updateData"                 
          class="ml-3"/>

        <v-row>
          <v-col cols="8">
            <v-divider class="mb-1"></v-divider>
          </v-col>
        </v-row>

        <weekdays_checkbox_addon 
          :days="wizardData.other_departure_days_remove"
          field="other_departure_days_remove"
          tag="Reset"     
          :selectAll="true"
          color="warning"
          info="Resets a departure day if checked and will overwrite 'days' value. Ignores day selection." 
          info_font_size="small"
          @updateData="updateData" 
          class="ml-3"/>

      </v-col>
    </v-row>  
    <v-row>
      <v-col cols="6">
        <div class="ml-3 mb-1"><b>Minimum number of nights</b></div>
        <v-divider class="mb-2"></v-divider>        

        <weekdays_labels class="ml-3"/>

        <!-- <weekdays_numerical_addon 
          :days="wizardData.other_min_nights_days_num"
          field="other_min_nights_days_num"
          tag="Days"
          info="'0' values are not saved. Instead use 'reset' to reset the minimum number of nights value." 
          info_font_size="small"          
          @updateData="updateData" 
          class="ml-3"/>         -->

        <weekdays_numerical_addon 
          :days="wizardData.other_min_nights_days_num"
          field="other_min_nights_days_num"
          tag="Days"
          info="'0' values are ignored." 
          info_font_size="small"          
          @updateData="updateData" 
          class="ml-3"/>        


        <v-row>
          <v-col cols="8">
            <!-- <v-divider class="mb-1"></v-divider> -->
          </v-col>
        </v-row>

        <!-- <weekdays_checkbox_addon 
          :days="wizardData.other_min_nights_days_remove"
          field="other_min_nights_remove"
          tag="Reset"     
          color="warning"
          info="Resets minimum number of nights. Ignores 'days' value." 
          info_font_size="small"
          @updateData="updateData" 
          class="ml-3"/> -->

      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="ml-3 mb-1"><b>Cleaning</b></div>        
        <v-divider class="mb-2"></v-divider>               
        <weekdays_labels class="ml-3"/> 

        <weekdays_numerical_addon 
          :days="wizardData.other_cleaning_days_num"
          field="other_cleaning_days_num"
          tag="Days"
          info="'0' values are not saved. Instead use 'reset' to reset the cleaning days value." 
          info_font_size="small"          
          @updateData="updateData" 
          class="ml-3"/>                

        <v-row>
          <v-col cols="8">
            <v-divider class="mb-1"></v-divider>
          </v-col>
        </v-row>

        <weekdays_checkbox_addon 
          :days="wizardData.other_cleaning_days_remove"
          field="other_cleaning_days_remove"
          tag="Reset"     
          :selectAll="true"
          color="warning"
          info="Resets cleaning days. Ignores 'days' value." 
          info_font_size="small"
          @updateData="updateData" 
          class="ml-3"/>

      </v-col>
      <v-col cols="6">
        <div class="ml-3 mb-1"><b>Planning</b></div>        
        <v-divider class="mb-2"></v-divider>      
                
        <weekdays 
          :days="wizardData.other_planning_days" 
          field="other_planning_days" 
          color="primary"
          @updateData="updateData" class="ml-3"/>

        <weekdays_numerical_planning_addon 
          :days="wizardData.other_planning_days_num"
          field="other_planning_days_num"
          tag="Days"
          info="0 = Bookable on contract <br> 2 = Not bookable, not on contract  <br>  3 = Not bookable, on contract  <br>  4 = Bookable on contract, not in price extensio <br><b>( '0' values are saved if the day is checked )</b>"
          info_font_size="small"
          @updateData="updateData" 
          class="ml-3"/>                          

      </v-col>

    </v-row>    
  </div>
</template>

<script>

  import weekdays from '@/components/huis/hspt/ui/weekdays.vue';
  import weekdays_labels from '@/components/ui/weekdays_labels.vue'
  import weekdays_numerical_addon from '@/components/huis/hspt/ui/weekdays_numerical_addon.vue'
  import weekdays_checkbox_addon from '@/components/huis/hspt/ui/weekdays_checkbox_addon.vue'
  import weekdays_numerical_planning_addon from '@/components/huis/hspt/ui/weekdays_numerical_planning_addon.vue'

  export default {
    props: {
      wizardData: Object
    },
    components: {
      weekdays,
      weekdays_labels,
      weekdays_numerical_addon,
      weekdays_checkbox_addon,
      weekdays_numerical_planning_addon,
    },   
    methods:{            
      updateNegativePlanning(value){
        this.wizardData.other_planning_days_override = value;
      },              
      updateData(data){
        this.$emit('updateData', data);      
      }        
    } 
  }
  
</script>

<style scoped>
  .avatar-icon{
    border-radius: 200px;
    width: 30px;
    height: 30px;
    border: solid 2px green;
  }
</style>